import ProductCategoryContainer from "components/productCategory/ProductCategoryContainer";

export default function ProductCategoryPage() {
  return <ProductCategoryContainer />;
}
